import { type StateCreator } from 'zustand';
import { type PathIds } from '#types.js';
import { type ContinueWatchingStore, type State, type Store } from './types.ts';

export const createContinueWatchingStore: (
  initialState: Partial<State>,
) => StateCreator<Store, [], [], ContinueWatchingStore> = initialState => (set, get) => ({
  addContinueWatchingTv: (pathIds: PathIds) => {
    const { continueWatchingTv } = get();

    if (continueWatchingTv.some(entry => entry[0] === pathIds[0])) {
      return;
    }

    set(state => ({
      continueWatchingTv: [pathIds, ...state.continueWatchingTv],
    }));
  },
  continueWatchingTv: initialState.continueWatchingTv ?? [],
  getContinueWatchingTvEntry: (tvId: string): PathIds | undefined => {
    return get().continueWatchingTv.find(([id]) => id === tvId);
  },
  hasContinueWatchingTv: () => {
    return get().continueWatchingTv.length > 0;
  },
  removeContinueWatchingTv: (tvId: string) => {
    const { continueWatchingTv } = get();

    if (!continueWatchingTv.some(([id]) => id === tvId)) {
      return;
    }

    set(state => {
      const index = state.continueWatchingTv.findIndex(([id]) => id === tvId);
      const newContinueWatchingTv = state.continueWatchingTv.toSpliced(index, 1);

      return {
        continueWatchingTv: newContinueWatchingTv,
      };
    });
  },
  updateContinueWatching: (pathIds: PathIds) => {
    const { addContinueWatchingTv, continueWatchingTv, removeContinueWatchingTv } = get();
    const currentEntry = continueWatchingTv.find(entry => entry[0] === pathIds[0]);

    if (currentEntry) {
      // @ts-expect-error TODO: Need to refactor so tvId is string
      removeContinueWatchingTv(currentEntry[0]);
    }

    addContinueWatchingTv(pathIds);
  },
});
